import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const CustomerAPI = createApi({
    reducerPath: "CustomerAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            if (!["blockCustomer"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({

        getCustomerList: builder.query({
            query: () => `admin/users/list-all-users`,
        }),
        getCustomerbyId: builder.query({
            query: (id) => `admin/users/show-user/${id}`,
        }),
        deleteCustomer: builder.mutation({
            query: (formData) => ({
                url: `/admin/delete-user`,
                method: "POST",
                body: formData
            }),
        }),
        blockCustomer: builder.mutation({
            query: (formData) => ({
                url: `/admin/change-user-status`,
                method: "POST",
                body: formData
            }),
        }),
        getOrderbyId: builder.query({
            query: (id) => `admin/orders/list-orders/${id}`,
        }),
        editCustomerData:builder.mutation({
            query: (formData) => ({
                url: `/admin/edit-user`,
                method: "POST",
                body: formData
            }),
        }),
    }),
});

export const { useGetCustomerListQuery, useGetCustomerbyIdQuery, useBlockCustomerMutation, useDeleteCustomerMutation , useGetOrderbyIdQuery, useEditCustomerDataMutation} = CustomerAPI;
